import { BaseStore } from "../stores/base_store"

import CollaboratorsAPI from "../api/collaborators_api";
import { CollaboratorsProps, Collaborators } from './collaborators_store';
import { api_post } from "api/utils";


export class UserCollaboratorsStore extends BaseStore<CollaboratorsProps, Collaborators> {

    getUserCollaborators() {
        return this.items.slice().sort((a, b) => {
            return a.date_created > b.date_created ? 1 : -1;
        });
    }

    async fetchIdentityCollaborators(identityKey: string, variant="collab", cursor = "") {
        // console.log("fetchIdentityCollaborators", identityKey, variant, cursor);
        return CollaboratorsAPI.listByIdentity(identityKey, variant, cursor).then((resp) => {
            if (!resp || !resp.items) {
                console.warn("fetchIdentityCollaborators: no response or items", resp);
                return [];
            }
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchIdentityCollaborators(identityKey, variant, resp.cursor);
            }
            return resp.items;
        })
    }

    async post_and_receive(url: string, data={}) {
        try {
            const resp = await api_post(url, data);
            const c = await resp.json();
            this.receiveUpdate(c);
            return c;
        } catch (error) {
            // handle or throw error
            console.error(error);
            throw new Error(`An error occurred while trying: ${url}`);
        }
    }


    /** supports snooze and leave */
    async take_action(identityKey: string, collab: string, action: string) {
        const data = { identity: identityKey, collab };
        try {
            const resp = await api_post(`/collaborators/${action}`, data);
            const responseData = await resp.json();
            this.receiveUpdate(responseData.collaborator);
        } catch (error) {
            // handle or throw error
            console.error(error);
            throw new Error(`An error occurred while trying to: ${action} from collab`);
        }
    }

    async revoke(revoke_identity: string, collab: string, identity: string) {
        const data = {
            revoke_identity: revoke_identity,
            collab: collab,
            identity: identity
        };
        return this.post_and_receive('/collaborators/revoke', data);
    }



    async remove(remove_identity: string, collab: string, identity: string) {
        const data = {
            remove_identity: remove_identity,
            collab: collab,
            identity: identity
        };
        return this.post_and_receive('/collaborators/remove', data);
    }


    modelConstructor() {
        return Collaborators;
    }

}
